import { ConversationAction } from '../actions/conversationActions';
import { FeatureAction } from '../actions/featureActions';
import { GptConfigurationsAction } from '../actions/gptConfigurationsAction';
import { QuotaAction } from '../actions/quotaActions';
import { RootStateAction } from '../actions/rootStateActions';
import { SurveyAction } from '../actions/surveyAction';
import { ThemeAction } from '../actions/themeActions';
import { ThemeModeAction } from '../actions/themeModeActions';
import { UserPreferencesAction } from '../actions/userPreferencesAction';
import { RootState } from '../models/rootState';
import { conversationsReducer } from './conversationsReducer';
import { featureFlagsReducer } from './featureFlagsReducer';
import { gptConfigurationsReducer } from './gptConfigurationsReducer';
import { quotaReducer } from './quotaReducer';
import { surveyReducer } from './surveyReducer';
import { themeReducer } from './themeReducer';
import { themeModeReducer } from './themeModeReducer';
import { userPreferencesReducer } from './userPreferencesReducer';

export const rootReducer = (state: RootState, action: RootStateAction): RootState => {
    const conversationAction = action as ConversationAction;

    // Calculer le nouveau themeMode
    const newThemeMode = themeModeReducer(state.themeMode, action as ThemeModeAction);
    
    // Détecter si le themeMode a changé
    const themeModeChanged = newThemeMode !== state.themeMode;
    
    // Calculer le nouveau state de base
    const newState: RootState = {
        chats: conversationsReducer(state.chats, conversationAction),
        conversationsCursor: conversationAction.type === 'SET_CONVERSATIONS' 
            ? conversationAction.cursor 
            : conversationAction.type === 'SET_CONVERSATIONS_CURSOR'
            ? conversationAction.payload
            : conversationAction.type === 'CLEAR_CONVERSATIONS'
            ? undefined
            : state.conversationsCursor,
        quota: quotaReducer(state.quota, action as QuotaAction),
        theme: themeReducer(state.theme, newThemeMode, action as ThemeAction),
        themeMode: newThemeMode,
        features: featureFlagsReducer(state.features, action as FeatureAction),
        userPreferences: userPreferencesReducer(state.userPreferences, action as UserPreferencesAction),
        gptConfigurations: gptConfigurationsReducer(state.gptConfigurations, action as GptConfigurationsAction),
        survey: surveyReducer(state.survey, action as SurveyAction),
        conversationsLoading: (action as any).type === 'SET_CONVERSATIONS_LOADING' ? (action as any).payload : state.conversationsLoading,
        appLoading: (action as any).type === 'SET_APP_LOADING' ? (action as any).payload : state.appLoading,
    };
    
    // Si le themeMode a changé, déclencher automatiquement le changement de thème
    if (themeModeChanged) {
        return {
            ...newState,
            theme: themeReducer(newState.theme, newThemeMode, { type: 'SWITCH_THEME' } as ThemeAction)
        };
    }
    
    return newState;
};

export default rootReducer;
